import EventEmitter from 'events';

export default class CustomEventEmitter extends EventEmitter {
    // override，添加signal参数
    addListener(
        eventName: string | symbol,
        listener: (...args: any[]) => void,
        options: {signal?: AbortSignal} = {}
    ): this {
        super.addListener(eventName, listener);

        if (options.signal) {
            this.setupAbortSignal(eventName, listener, options.signal);
        }

        return this;
    }

    // override，添加signal参数
    on(
        eventName: string | symbol,
        listener: (...args: any[]) => void,
        options: {signal?: AbortSignal} = {}
    ): this {
        return this.addListener(eventName, listener, options);
    }

    // 设置abort信号和回调
    private setupAbortSignal(
        eventName: string | symbol,
        listener: (...args: any[]) => void,
        signal: AbortSignal
    ): void {
        if (signal.aborted) {
            return;
        }

        const abortHandler = () => {
            this.removeListener(eventName, listener);
        };
        signal.addEventListener('abort', abortHandler, {
            once: true,
        });
    }
}